module.exports = "https://coursera_assets.s3.amazonaws.com/images/e8c5ad93424a1ff36f706d83d78e432f.png";